(function(){
  function ready(fn){ if(document.readyState!=='loading')fn(); else document.addEventListener('DOMContentLoaded',fn); }
  // Cooperative guard: a hand-authored section that ships its OWN toggle script
  // marks its wrapper [data-cc-skip] so this catch-all leaves it alone and we
  // never double-bind (two handlers cancel out). Also dedupes our own binds.
  function skip(el){ return !!(el.closest && el.closest('[data-cc-skip]')); }
  ready(function(){
    // 1) accordion items: header toggles its item's .active (captured CSS
    //    keys open state off .active). Works for .accordion-item/.accordion-header.
    var heads = [].slice.call(document.querySelectorAll('.accordion-header,[class*=accordion__header],[class*=accordion-trigger],[class*=collapsible__header],[class*=collapsible-trigger]'));
    heads.forEach(function(h){
      if(skip(h) || h.dataset.ccBound==='1') return;
      h.dataset.ccBound='1';
      h.setAttribute('role','button'); h.setAttribute('tabindex','0');
      function toggle(){
        var item = h.closest('.accordion-item,[class*=accordion__item],[class*=collapsible__item]') || h.parentElement;
        if(!item) return;
        var open = item.classList.contains('active')||item.classList.contains('is-open')||item.classList.contains('open');
        // single-open within the same list (optional, natural for FAQs)
        var list = item.parentElement;
        if(list){ [].slice.call(list.children).forEach(function(sib){ if(sib!==item) sib.classList.remove('active','is-open','open'); }); }
        item.classList.toggle('active', !open); item.classList.toggle('is-open', !open); item.classList.toggle('open', !open);
      }
      h.addEventListener('click', function(e){ e.preventDefault(); toggle(); });
      h.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); } });
    });
    // 2) tab strips: a .tab-button shows its matching .tab-content. Target
    //    resolution order: data-tab / aria-controls → the id inside a legacy
    //    inline onclick="openTab(e,'tabN')" → positional (Nth button ⇒ Nth panel).
    var tabWraps = [].slice.call(document.querySelectorAll('[class*=tabs-section],[class*=tab-wrapper],[role=tablist]'));
    if(!tabWraps.length){ var anyBtn=document.querySelector('.tab-button,[class*=tab-button]'); if(anyBtn){ var w=anyBtn.closest('section,div'); if(w) tabWraps=[w]; } }
    tabWraps.forEach(function(wrap){
      if(skip(wrap) || wrap.dataset.ccBound==='1') return;
      wrap.dataset.ccBound='1';
      var btns=[].slice.call(wrap.querySelectorAll('.tab-button,[class*=tab-button],[role=tab]'));
      var panels=[].slice.call(wrap.querySelectorAll('.tab-content,[class*=tab-content],[role=tabpanel]'));
      function keyFor(b){ var k=b.getAttribute('data-tab')||b.getAttribute('aria-controls'); if(k) return k; var oc=b.getAttribute('onclick')||''; var m=oc.match(/['\"]([\w-]+)['\"]\s*\)?\s*$/); return m?m[1]:null; }
      btns.forEach(function(b,i){
        b.removeAttribute('onclick');
        b.addEventListener('click', function(e){
          e.preventDefault();
          var key=keyFor(b);
          btns.forEach(function(x){ x.classList.remove('active','is-active'); });
          b.classList.add('active','is-active');
          panels.forEach(function(p,pi){ var on = key ? (p.id===key||p.getAttribute('data-tab')===key) : (pi===i); p.classList.toggle('active', !!on); p.classList.toggle('is-active', !!on); p.style.display = on ? '' : 'none'; });
        });
      });
    });
  });
})();